import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    display: "flex",
    alignItems: "center"
  },
  expirationCount: {
    fontSize: 20,
    color: theme.palette.text.primary
  },
  highAttention: {
    color: theme.palette.error.main
  },
  attentionIconWrapper: {
    display: "inline-block",
    width: 20
  },
  attentionIcon: {
    fontSize: 20,
    color: theme.palette.error.main,
    position: "relative",
    top: 1
  }
}));
